import {observer} from 'mobx-react';
import React from 'react';
import {userStatusService} from '../../domain';
import {AdministratorDashboard} from './parts/AdministratorDashboard';
import {ContentManagerDashboard} from './parts/ContentManagerDashboard';
import StudentDashboard from './parts/student/StudentDashboard';
import {TeacherDashboard} from './parts/TeacherDashboard';

@observer
export class DashboardPage extends React.Component {
  render() {
    const roles = userStatusService.status.roles;

    return (
      <>
        {
          roles.Administrator &&
          <AdministratorDashboard/>
        }

        {
          roles.ContentManager &&
          <ContentManagerDashboard/>
        }

        {
          roles.Student &&
          <StudentDashboard/>
        }

        {
          roles.Teacher &&
          <TeacherDashboard/>
        }
      </>
    );
  }
}
